import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./project_detail.css";
import {
  Clock,
  Calendar,
  Layers,
  ChevronRight
} from "lucide-react";

const ProjectDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { project, totalStats } = location.state || {};
  const stats = totalStats || { formattedHours: "0 hr: 0 mins", formattedDays: "0 day" };

  if (!project) {
    return (
      <div className="project-detail-container">
        <div className="detail-card">
          <p>No project data found. Please go back and try again.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="project-detail-container">
      <div className="detail-header">
        <div className="header-left">
          <h2>{project.projectname}</h2>
          <p>Project Management System</p>
        </div>
        <div className="project-id-badge">ID: {project.projectid}</div>
      </div>

      <div className="detail-grid">
        <div className="left-side">
          <div className="detail-card">
            <h3>Project Overview</h3>
            <div className="description-box">
              {project.description || "No description provided for this project."}
            </div>
          </div>

          <div className="detail-card professional-modules-card">
            <div className="card-header-with-icon">
              <Layers size={20} className="header-icon" />
              <h3>Assigned Modules</h3>
            </div>
            <div className="modules-compact-list">
              {project.modules?.map((mod) => (
                <div
                  key={mod.assignmentid}
                  className={`module-sleek-row status-${(mod.status || "progress").toLowerCase()}`}
                >
                  <div className="module-content-main">
                    <div className="module-primary-info">
                      <div className="module-title-box">
                        <div className="module-status-dot"></div>
                        <h4>{mod.modulename}</h4>
                      </div>
                      <div className="module-status-wrapper">
                        {mod.status && mod.status.toLowerCase() !== "progress" && (
                          <span className={`status-pill-modern ${mod.status.toLowerCase()}`}>
                            {mod.status}
                          </span>
                        )}
                      </div>
                    </div>

                    <p className="module-description-preview">
                      {mod.description ||
                        "No specific instructions provided for this module."}
                    </p>

                    <div className="module-footer-meta">
                      <div className="meta-pill-group">
                        <div className="meta-pill-modern">
                          <Calendar size={14} />
                          <span>
                            {mod.deadlinedate
                              ? new Date(mod.deadlinedate).toLocaleDateString("en-GB")
                              : mod.updatedAt
                                ? new Date(mod.updatedAt).toLocaleDateString("en-GB")
                                : "N/A"}
                          </span>
                        </div>
                      </div>
                      <div className="module-action-area">
                        <button
                          className="modern-report-btn"
                          onClick={() =>
                            navigate("/add-workreports", {
                              state: {
                                projectid: project.projectid,
                                moduleid: mod.moduleid,
                              },
                            })
                          }
                        >
                          <span>Add Report</span>
                          <ChevronRight size={16} />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="right-side">
          <div className="detail-card">
            <h3>Total Performance Stats</h3>
            <div className="stats-card">
              <div className="stat-item">
                <div className="stat-icon" style={{ color: "#10B981" }}>
                  <Calendar size={24} />
                </div>
                <div className="stat-info">
                  <label>Total Worked Days</label>
                  <p>{stats.formattedDays}</p>
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-icon" style={{ color: "#eb006a" }}>
                  <Clock size={24} />
                </div>
                <div className="stat-info">
                  <label>Total Worked Hours</label>
                  <p>{stats.formattedHours}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetail;
